export default class LangSwitcher {
    constructor() {
        this.init();
    }

    init() {
        const ukRedirectGuardCookie = costorage.get('h_uk-redirect-guard');

        if (ukRedirectGuardCookie) {
            return;
        }

        const $ruLangSwitchers = document.querySelectorAll('[data-lang-switcher="ru"]');

        if ($ruLangSwitchers.length) {
            $ruLangSwitchers.forEach(($langSwitcher) => {
                $langSwitcher.addEventListener('click', () => {
                    costorage.set('h_uk-redirect-guard', 1, { expires: (5 * 24 * 60 * 60), path: '/', domain: '.ithillel.ua' });
                });
            });
        }
    }
}